<template>
    <v-row>           
    <v-col>
        <v-card
            class="pa-4 mx-auto rounded-xl"
            width="700"
            height="75vh"
        >
            <v-card-title>
                Reset Employee Password
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details=""
                    clearable
                ></v-text-field>
            </v-card-title>
            <v-data-table
                class="mt-10"
                :headers="headers"
                :items="employees"
                :search="search"
                fixed-header
                height="45vh"
                :loading="loading"
            >
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                        medium
                        class="mr-2"
                        @click="resetPassword(item)"
                    >
                        mdi-lock-reset
                    </v-icon>
                </template>
            </v-data-table>

            <v-dialog
                v-model="dialog"
                persistent
                max-width="380"
            >
                <v-card
                    class="pa-4 rounded-xl"
                >
                    <v-card-title>
                        {{ cardTitle }}
                    </v-card-title>
                    <v-card-text
                        class='text-subtitle-1 font-weight-bold'
                    >
                        {{ cardText }}
                    </v-card-text>
                    <v-progress-linear
                        indeterminate
                        v-if="progress"
                    ></v-progress-linear>

                    <v-card-actions class="d-flex justify-space-between">
                        <v-btn
                            outlined
                            @click="dialog = false"
                            v-if="cancel"
                            width="160"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="resetPasswordConfirm"
                            v-if="ok"
                            width="160"
                        >
                            Reset Password
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="dialog = false"
                            v-if="close"
                            width="160"
                            block
                        >
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </v-col>
    </v-row>        
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
export default {
    created () {
        this.initialize();
    },

    watch: {
        dialog (val){
            if(val){
                this.cancel = true;
                this.ok = true;
                this.close = false;
            }
        }
    },
   
    data: () => ({
        search: '',
        employees: [],
        headers: [
            {text: 'ID', align: 'start', sortable: 'false', value: 'id', width: '50'},
            {text: 'Last Name', value: 'lastName', width: '100'},
            {text: 'First Name', value: 'firstName', width: '100'},
            {text: 'User Name', value: 'userName', width: '100'},
            {text: 'Reset', value: 'actions', sortable: 'false', width: '50'}
        ],
        loading: true,
        cardText: '',
        cardTitle: '',
        employeeId: null,
        dialog: false,
        progress: false,
        cancel: true,
        ok: true,
        close: false,
    }),

    methods: {        
        ...mapActions({
            getEmployees: 'employees/getEmployees',
            resetPasswordPost: 'auth/resetPassword',
        }),
        ...mapMutations({
            setResetEmployeeId: 'auth/setResetEmployeeId',
        }),
        async initialize(){
            console.log('initializing...')
            try {
                const employeePromise = await this.getEmployees();                
                let records = employeePromise.data;
                //console.log(records);
                records.forEach(record => {
                    let employee = {
                        id: record.id,
                        lastName: record.last_name,
                        firstName: record.first_name,
                        userName: record.user_name
                    }
                    this.employees.push(employee); 
                })
                this.loading = false;
            } catch (error) {
                console.log(error);
            }
        },
        resetPassword({ id, firstName, lastName }) {
            this.employeeId = id;
            this.dialog = true;
            this.cardTitle = 'Are you sure you want to reset';
            this.cardText = firstName + ' ' + lastName;
        },
        resetPasswordConfirm(){
            this.cardTitle = 'Please wait..';
            this.cardText = '';
            this.ok = false,
            this.cancel = false,
            this.progress = true;
            this.postReset();
        },
        async postReset(){            
            this.setResetEmployeeId(this.employeeId);
            try {
                const { data } = await this.resetPasswordPost();
                this.cardTitle = "Password reset successfully."
                this.cardText = "New Password: " + data.remember_token
            } catch (error) {
                console.log(error);
                if(error.response) console.log(error.response)
                this.cardTitle = "An error has occured " + error.status
            } finally {
                this.progress = false;
                this.ok = false;
                this.close = true;
            }
            
        },        
        
        
    }
}
</script>